import get from 'lodash/get';
import moment from 'moment';
import config from "../config";

export const getStampCollectionId = (appType) => {
  const { stampCollectionTWId, stampCollectionYLId } = config;
  if (appType === 'kolour_yl') {
    return stampCollectionYLId;
  }
  return stampCollectionTWId;
};

export const getCouponTemplateId = (appType) => {
  const { couponTemplateTWId, couponTemplateYLId } = config;
  if (appType === 'kolour_yl') {
    return couponTemplateYLId;
  }
  return couponTemplateTWId;
};

export const getUserStatus = (stampCollection, userStamps, coupopn) => {
  if (get(coupopn, 'status') === 'redeemed') {
    return 'completed';
  }
  let userStatus = 'started';
  const isSuccess = get(stampCollection, 'stamp_templates', []).every(stampTemplate => {
    const matchUserStamp = userStamps.find(userStamp => userStamp.stamp_template === stampTemplate.stamp_template_id);
    return !!matchUserStamp;
  });
  if (isSuccess) {
    userStatus = 'success';
  }
  return userStatus;
};

export const isDateValid = () => {
  const now = moment();
  const eventStartDate = moment('2020-11-23');
  const eventEndDate = moment('2021-05-01');
  return (now.isSameOrAfter(eventStartDate, 'day') && now.isSameOrBefore(eventEndDate, 'day'));
};
